import React from 'react'; 
import TitleWithSubtext from '../../common/TitleWithSubtext';
import PropTypes from 'prop-types';

function AboutSection({content}) {

	const { value: titleWithSubtext } = content['landingAbout.intro']; 
	const MagdalaImage = 'https://instituteofcatholicculture.net/wp-content/uploads/2026/09/2026-Magdala-pic-to-replace-video-scaled_v3.jpg';

	return (
		<div className="Magdala-About">
			<TitleWithSubtext titleWithSubtext={titleWithSubtext} useHeadingForPage={true} />
			<img src={MagdalaImage} alt="Magdala" className="Magdala-About-image" />
		</div>
	)
}

AboutSection.propTypes = {
	content: PropTypes.object
}

export default AboutSection; 
